import { useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { fetchUserData } from "../components/auth";
import { UserDataContext } from "./UserDataContext";
import LogoutIcon from "@mui/icons-material/Logout";
import DateComponent from "./DateComponent";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import SecurityIcon from "@mui/icons-material/Security";
import EngineeringIcon from "@mui/icons-material/Engineering";
import "./Menu.css";
import { NavLink } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { apiRequest } from "../components/Config";
import EuroIcon from "@mui/icons-material/Euro";

function VN() {
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [expire, setExpire] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (userData && userData.permId !== "2") {
      setMenuItems([
        {
          id: 1,
          name: "ZLECENIA",
          path: "/tasks",
          icon: <FormatListNumberedIcon />,
        },
        {
          id: 2,
          name: "OSOBY UPRAWNIONE",
          path: "/internalUsers",
          icon: <SecurityIcon />,
        },
        {
          id: 3,
          name: "WYKONAWCY",
          path: "/performers",
          icon: <EngineeringIcon />,
        },
        {
          id: 4,
          name: "SKŁADKI",
          path: "/contributions",
          icon: <EuroIcon />,
        },
        {
          id: 5,
          name: "",
          path: "/login",
          icon: <LogoutIcon onClick={logout} />,
        },
      ]);
    }
    if (userData && userData.permId === "2") {
      setMenuItems([
        {
          id: 1,
          name: "ZLECENIA",
          path: "/tasks",
          icon: <FormatListNumberedIcon />,
        },

        {
          id: 5,
          name: "",
          path: "/login",
          icon: <LogoutIcon onClick={logout} />,
        },
      ]);
    }
    if (userData && userData.permId === "0") {
      setMenuItems([{ id: 1, name: "", path: "/login" }]);
    }
  }, [userData, setMenuItems]);

  const logout = async () => {
    try {
      await apiRequest("logout", "POST");
      setUserData({
        userId: 0,
        user: "",
        permId: "0",
        fullName: "",
        grpName: "",
        description: "",
        is_active: "0",
        phone: "",
        idGrp: "0",
      });
      //navigate("/login");
    } catch (error) {
      console.error("Błąd podczas wylogowywania:", error);
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
          setExpire(userDataAnswer.expire);
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Error during user verification:", error);

        navigate("/login");
      } finally {
        setLoading(false);
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  useEffect(() => {
    if (expire) {
      const compareDateWithToday = (inputDate) => {
        const today = new Date();
        const input = new Date(inputDate);
        today.setHours(0, 0, 0, 0);
        input.setHours(0, 0, 0, 0);
        if (input < today) {
          navigate("/expired");
        }
      };
      compareDateWithToday(expire);
    }
  }, [expire, navigate]);

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <header className="menu-container">
        {/* LOGO */}
        <p className="p8">{!loading && userData ? userData.fullName : ""}</p>

        {/* HAMBURGER - tylko na mobile */}
        {isMobile && (
          <button className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? "✖" : "☰"}
          </button>
        )}

        {/* MENU */}
        {!loading && userData && (
          <nav
            className={`menu ${
              isMobile ? (isOpen ? "open" : "closed") : "desktop"
            }`}
          >
            <ul>
              {menuItems.map((item) => (
                <li key={item.id}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => (isActive ? "active" : "")}
                    onClick={() => isMobile && setIsOpen(false)}
                  >
                    <p className="p4">
                      {item.icon} {item.name}
                    </p>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        )}
        {!loading && userData && (
          <Tooltip title="Ustawienia">
            <SettingsOutlinedIcon
              onClick={handleOpenUserMenu}
              sx={{ p: 0 }}
              style={{
                color: "#ffffff",
                display: "block",
                padding: "0px",
              }}
            />
          </Tooltip>
        )}
        {/*
        {!loading && userData && (
          <Button key="0" onClick={logout} sx={{ my: 2 }}>
            <p className="p4">
              <LogoutIcon />
              Wyloguj
            </p>
          </Button>
        )}
          */}
        {!loading && userData && userData.permId !== 0 && (
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem key="1" onClick={() => navigate("/passchange")}>
              <Typography sx={{ textAlign: "center" }}>Zmiana hasła</Typography>
            </MenuItem>
            <MenuItem key="2" onClick={() => navigate("/appdescription")}>
              <Typography sx={{ textAlign: "center" }}>
                Opis działania
              </Typography>
            </MenuItem>
          </Menu>
        )}
      </header>
    </>
  );
}

export default VN;
